// Outil fondateur : se balader sur le site comme un VRAI visiteur non connecté,
// sans perdre sa session. La session est mise de côté, puis restaurée en un clic.
//
// Activer  : ajouter ?visiteur=1 à l'URL (ex. monsite.com/?visiteur=1)
// Revenir  : bouton flottant « Revenir à mon compte » en bas à gauche
import { useState, useEffect } from 'react';

const CLES_SESSION = [
  'ecosystem_token',
  'client_token',
  'buyer_token',
  'ecosystem_user',
  'ecosystem_profile',
  'buyer_user',
];
const CLE_SAUVEGARDE = 'abracada_session_sauvegardee';

export default function ModeVisiteur() {
  const [actif, setActif] = useState(() => {
    try {
      return !!localStorage.getItem(CLE_SAUVEGARDE);
    } catch {
      return false;
    }
  });

  // Activation via ?visiteur=1 : on met la session de côté et on repart à l'accueil
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('visiteur') === '1' && !localStorage.getItem(CLE_SAUVEGARDE)) {
        const sauvegarde = {};
        CLES_SESSION.forEach((cle) => {
          const valeur = localStorage.getItem(cle);
          if (valeur !== null) sauvegarde[cle] = valeur;
        });
        localStorage.setItem(CLE_SAUVEGARDE, JSON.stringify(sauvegarde));
        CLES_SESSION.forEach((cle) => localStorage.removeItem(cle));
        window.location.replace('/');
      }
    } catch {
      // localStorage indisponible : on ne fait rien
    }
  }, []);

  const revenir = () => {
    try {
      const brut = localStorage.getItem(CLE_SAUVEGARDE);
      if (brut) {
        const sauvegarde = JSON.parse(brut);
        Object.entries(sauvegarde).forEach(([cle, valeur]) =>
          localStorage.setItem(cle, valeur)
        );
      }
      localStorage.removeItem(CLE_SAUVEGARDE);
    } catch {
      // au pire on retire juste le drapeau
      try { localStorage.removeItem(CLE_SAUVEGARDE); } catch {}
    }
    window.location.replace('/');
  };

  if (!actif) return null;

  return (
    <button
      onClick={revenir}
      className="fixed bottom-4 left-4 z-[12000] flex items-center gap-2 px-4 py-2.5 rounded-full shadow-xl text-white text-sm font-semibold hover:brightness-110 transition"
      style={{ background: 'linear-gradient(135deg, #1E3A5F 0%, #152a45 100%)', border: '1px solid rgba(255,255,255,0.25)' }}
      title="Tu navigues en mode visiteur — clique pour retrouver ton compte"
    >
      👁 Mode visiteur — Revenir à mon compte
    </button>
  );
}
